import { useState } from 'react';
import { useCallback, useEffect } from 'preact/compat';
function useCheckoutPrice(activities) {
    const [standardPrice, setStandardPrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    console.log('Calculating price for: ', activities);
    const calculateStandardPrice = useCallback(() => {
        const standardPriceSum = activities.reduce((total, activity) => {
            let price = 0;
            if (activity.activeSession) {
                price = activity.activeSession.StandardPrice;
            }
            return total + price;
        }, 0);
        setStandardPrice(standardPriceSum);
    }, [activities]);
    const calculateTotalPrice = useCallback(() => {
        const totalPriceSum = activities.reduce((total, activity) => {
            let price = 0;
            if (activity.activeSession) {
                price = activity.activeSession.TotalPrice;
            }
            return total + price;
        }, 0);
        setTotalPrice(totalPriceSum);
    }, [activities]);
    useEffect(calculateStandardPrice, [activities]);
    useEffect(calculateTotalPrice, [activities]);
    return {
        standardPrice,
        totalPrice,
    };
}
export default useCheckoutPrice;
